import { render, staticRenderFns } from "./ModulePicker.vue?vue&type=template&id=7ecc6400&"
import script from "./ModulePicker.vue?vue&type=script&lang=ts&"
export * from "./ModulePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports